export const defaultKinds = ['Component', 'System', 'API', 'Domain', 'Resource']